import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.19 8.268V8a6 6 0 0 0-12 0v.268a2 2 0 0 1 3 1.732v2a2 2 0 0 1-4 0V8a7 7 0 0 1 14 0v4a2 2 0 0 1-4 0v-2a2 2 0 0 1 3-1.732m0 1.732a1 1 0 1 0-2 0v2a1 1 0 0 0 2 0zm-12 0v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })